import React from "react";
import { CardActionArea, CardContent, CardMedia, Stack } from "@mui/material";
import { InnerWrapper, OuterWrapper } from "../../wrapper/wrapper";
import ContentData from "./content";
import { CardBody, CardTitle, SubTitle, Title } from "./whyUs.components";

function WhyUs() {
  return (
    <OuterWrapper sx={{ bgcolor: "#E5E6ED", pt: "65px", pb: "43px" }}>
      <InnerWrapper>
        <Title sx={{ px: { xs: 1.5 }, fontSize: { xs: 28, sm: 32 } }}>
          Why Choose Us
        </Title>
        <SubTitle sx={{ px: { xs: 1.5 } }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit dolor sit
          amet, consectetur adipiscing elit
        </SubTitle>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="center"
          alignItems="center"
          spacing={6}
          sx={{ px: { xs: 1.5 } }}
        >
          {ContentData.map((data) => {
            return (
              <CardBody>
                <CardActionArea>
                  <CardMedia component="img" image={data.imgUrl} alt="" />
                  <CardContent>
                    <CardTitle
                      sx={{ height: { xs: "initial", sm: 80, md: "initial" } }}
                    >
                      {data.title}
                    </CardTitle>
                  </CardContent>
                </CardActionArea>
              </CardBody>
            );
          })}
        </Stack>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default WhyUs;
